import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseComponent} from "../../../../../../../../base/components/base.component";
import {EventBusService} from "../../../../../../../../base/services/eventbus/event-bus.service";
import {Router} from "@angular/router";
import {SubscriptionContainerService} from "../../../../../../../../base/services/subscription-container.service";
import {HttpErrorResponse} from "@angular/common/http";
import {NotifierService} from "../../../../../../../../base/services/notifier/notifier.service";
import {DeleteService} from "../../services/delete.service";

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent extends BaseComponent {

  @Input() requestUrl: string
  @Output() deleteItemEvent: EventEmitter<Boolean> = new EventEmitter()

  @Input() look: "fa" | "bx" = "fa"

  protected componentName(): string {
    return DeleteComponent.name;
  }

  constructor(eventBus: EventBusService,
              router: Router,
              subContainer: SubscriptionContainerService,
              private notifier: NotifierService,
              private deleteService: DeleteService) {
    super(eventBus, router, subContainer)
  }

  ngOnInit(): void {
  }

  deleteItem() {
    let conf = confirm("Are you sure to continue?")
    if (!conf) return
    let key = this.componentKey(this.requestUrl)
    this.deleteService.deleteItem(key, this.requestUrl)

    this.subscribe(key, null, (value, meta) => {
      this.deleteItemEvent.emit(true)
    })
    this.subscribe(this.getErrorKey(key), null, (value, meta) => {
      let err: HttpErrorResponse = meta.data
      this.notifier.error('Error!', err.error.message)
      this.deleteItemEvent.emit(false)
    })
  }

}
